var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import VentanaSimple from '../../ventana-simple';
import Botonera from '../../ventana-simple/botonera';
import ContenidoVentana from '../../contenido-ventana';
import Pizarra from '../../pizarra/pizarra';
import CartulinaContainer from '../../cartulina';
import MascarasContainer from '../../mascaras';
import PersianaContainer from '../../persiana';
import { Util } from '../../index'; // import { VENTANA_MARCO_AMPLIACION_ID } from '../ventana/constantes'
// import Botonera from './botonera'
// import Pizarra from '../../pizarra/components/pizarra'

import PanelTextos from '../../texto-usuario/components/panel-textos';

var vinculoAZona = function vinculoAZona(zonaId) {
  return {
    vinculo: 'funcion,abrirZona:' + zonaId
  };
};

var TAM_FUENTE_BASE_NOMINAL = 16;

var calcularRecorte = function calcularRecorte(coordenadas) {
  var acumuladorInicial = {
    xMin: 99999,
    yMin: 99999,
    xMax: 0,
    yMax: 0
  };
  var limites = coordenadas.reduce(function (acumulador, _ref) {
    var x = _ref[0],
        y = _ref[1];
    var xMin = acumulador.xMin,
        yMin = acumulador.yMin,
        xMax = acumulador.xMax,
        yMax = acumulador.yMax;

    if (x < xMin) {
      acumulador.xMin = x;
    }

    if (x > xMax) {
      acumulador.xMax = x;
    }

    if (y < yMin) {
      acumulador.yMin = y;
    }

    if (y > yMax) {
      acumulador.yMax = y;
    }

    return acumulador;
  }, acumuladorInicial);
  var xMin = limites.xMin,
      yMin = limites.yMin,
      xMax = limites.xMax,
      yMax = limites.yMax;
  return {
    sx: xMin,
    sy: yMin,
    sw: xMax - xMin,
    sh: yMax - yMin
  };
};

var PrimeraVentana = (_temp = _class = function (_Component) {
  _inherits(PrimeraVentana, _Component);

  function PrimeraVentana(props) {
    _classCallCheck(this, PrimeraVentana);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.zoomMas = function () {
      var configZoom = _this.props.configPrimeraVentana;
      var factor = _this.state.factor;
      var aumentoZoom = configZoom.aumento || 0;
      var multiplicadorZoom = configZoom.multiplicador || 1;
      var pasosZoom = configZoom.maxPasos || 0;
      var maxFactor = 100;

      for (var i = 0; i < pasosZoom; i++) {
        maxFactor = multiplicadorZoom * maxFactor + aumentoZoom;
      }

      var nextFactor = multiplicadorZoom * factor + aumentoZoom;

      if (nextFactor <= maxFactor) {
        _this.setState({
          factor: nextFactor
        }, function () {
          return _this.forceUpdate();
        });
      }
    };

    _this.zoomMenos = function () {
      var configZoom = _this.props.configPrimeraVentana;
      var factor = _this.state.factor;
      var aumentoZoom = configZoom.aumento || 0;
      var multiplicadorZoom = configZoom.multiplicador || 1;
      var pasosZoom = configZoom.minPasos || 0;
      var minFactor = 100;

      for (var i = 0; i < pasosZoom; i++) {
        minFactor = (minFactor - aumentoZoom) / multiplicadorZoom;
      }

      var nextFactor = (factor - aumentoZoom) / multiplicadorZoom;

      if (nextFactor >= minFactor) {
        _this.setState({
          factor: nextFactor
        }, function () {
          return _this.forceUpdate();
        });
      }
    };

    _this.zoomInicial = function () {
      _this.setState({
        factor: 100
      }, function () {
        return _this.forceUpdate();
      });
    };

    _this.mostrarInfoZona = function (e) {
      // Ctrl +  e
      if (e.ctrlKey && e.keyCode === 69) {
        window.console.info("primera-ventana props", _this.props);
      }
    };

    _this.renderContenidoTipoIframe = function () {
      var _this$props = _this.props,
          imagenUsuarioVisible = _this$props.imagenUsuarioVisible,
          textosUsuarioVisible = _this$props.textosUsuarioVisible,
          contenido = _this$props.contenido;
      return React.createElement(ContenidoVentana.ContenidoTipoIframe, _extends({
        imagenUsuarioVisible: imagenUsuarioVisible
      }, contenido), React.createElement(Pizarra, {
        visible: imagenUsuarioVisible,
        resolucion: {
          w: 1024,
          h: 700
        }
      }), textosUsuarioVisible && _this.renderTextosUsuario(), React.createElement(MascarasContainer, null), React.createElement(CartulinaContainer, null));
    };

    _this.renderContenidoTipoZoom = function () {
      var _this$props2 = _this.props,
          configLibros = _this$props2.configLibros,
          textosUsuarioVisible = _this$props2.textosUsuarioVisible,
          imagenUsuarioVisible = _this$props2.imagenUsuarioVisible,
          contenido = _this$props2.contenido,
          consolaLupa = _this$props2.consolaLupa,
          ajuste = _this$props2.ajuste,
          escala = _this$props2.escala;
      var imagen = contenido.imagen,
          coordenadas = contenido.coordenadas;
      var _this$state = _this.state,
          width = _this$state.width,
          height = _this$state.height,
          factor = _this$state.factor;
      var recorte = calcularRecorte(coordenadas);
      var lupa = consolaLupa.split(',')[0];
      return React.createElement(ContenidoVentana.ContenidoTipoZoom, {
        // marcoAmpliacionId={ this.getMarcoAmpliacionId() }
        factor: factor,
        imagen: imagen,
        coordenadas: coordenadas,
        ajuste: ajuste || "auto",
        escala: escala || 100,
        lupa: lupa,
        configLibros: configLibros,
        esPrimeraVentana: true,
        contenido: contenido,
        anchoDisponible: width,
        altoDisponible: height
      }, React.createElement(Pizarra, {
        visible: imagenUsuarioVisible,
        resolucion: {
          w: recorte.sw,
          h: recorte.sh
        }
      }), textosUsuarioVisible && _this.renderTextosUsuario(), React.createElement(MascarasContainer, null), React.createElement(CartulinaContainer, null), React.createElement(PersianaContainer, null));
    };

    _this.renderContenidoTipoVideo = function () {
      var _this$props3 = _this.props,
          imagenUsuarioVisible = _this$props3.imagenUsuarioVisible,
          textosUsuarioVisible = _this$props3.textosUsuarioVisible,
          contenido = _this$props3.contenido,
          onBoton = _this$props3.onBoton; // const marcoAmpliacionId = this.getMarcoAmpliacionId()

      var autoplay = contenido.autoplay,
          carpeta = contenido.carpeta,
          archivo = contenido.archivo,
          numVideosCarrusel = contenido.numVideosCarrusel,
          titulo = contenido.titulo,
          zonaAnterior = contenido.zonaAnterior,
          zonaSiguiente = contenido.zonaSiguiente;
      var onAnterior = zonaAnterior ? function () {
        return onBoton(vinculoAZona(contenido.zonaAnterior));
      } : false;
      var onSiguiente = zonaSiguiente ? function () {
        return onBoton(vinculoAZona(contenido.zonaSiguiente));
      } : false;
      return React.createElement(ContenidoVentana.ContenidoTipoVideo, _extends({
        // marcoAmpliacionId={ marcoAmpliacionId }
        autoPlay: autoplay,
        archivo: archivo,
        numVideosCarrusel: numVideosCarrusel,
        titulo: titulo,
        carpeta: carpeta
      }, contenido, {
        onSiguiente: onSiguiente,
        onAnterior: onAnterior
      }), React.createElement(Pizarra, {
        visible: imagenUsuarioVisible,
        resolucion: {
          w: 1000,
          h: 1000
        }
      }), textosUsuarioVisible && _this.renderTextosUsuario(), React.createElement(MascarasContainer, null), React.createElement(CartulinaContainer, null));
    };

    _this.renderContenidoTipoHistoria = function () {
      var _this$props4 = _this.props,
          imagenUsuarioVisible = _this$props4.imagenUsuarioVisible,
          textosUsuarioVisible = _this$props4.textosUsuarioVisible,
          libroId = _this$props4.libroId,
          numPagina = _this$props4.numPagina,
          contenido = _this$props4.contenido,
          pizarra = _this$props4.pizarra,
          onBoton = _this$props4.onBoton;

      if (contenido.numPaso === 'AUTO') {
        return React.createElement(ContenidoVentana.ContenidoTipoHistoriaAuto, _extends({
          libroId: libroId,
          numPagina: numPagina
        }, contenido, {
          pizarra: pizarra,
          onBoton: onBoton
        }), React.createElement(Pizarra, {
          visible: imagenUsuarioVisible,
          resolucion: {
            w: 1000,
            h: 1000
          }
        }), textosUsuarioVisible && _this.renderTextosUsuario(), React.createElement(MascarasContainer, null), React.createElement(CartulinaContainer, null));
      }

      return React.createElement(ContenidoVentana.ContenidoTipoHistoriaManual, _extends({
        libroId: libroId,
        numPagina: numPagina
      }, contenido, {
        pizarra: pizarra,
        onBoton: onBoton
      }), React.createElement(Pizarra, {
        visible: imagenUsuarioVisible,
        resolucion: {
          w: 1000,
          h: 1000
        }
      }), textosUsuarioVisible && _this.renderTextosUsuario(), React.createElement(MascarasContainer, null), React.createElement(CartulinaContainer, null));
    };

    _this.renderContenidoTipoFlashcards = function () {
      var _this$props5 = _this.props,
          imagenUsuarioVisible = _this$props5.imagenUsuarioVisible,
          textosUsuarioVisible = _this$props5.textosUsuarioVisible;
      return React.createElement(ContenidoVentana.ContenidoTipoFlashcards, _this.props.contenido, React.createElement(Pizarra, {
        visible: imagenUsuarioVisible,
        resolucion: {
          w: 1000,
          h: 1000
        }
      }), textosUsuarioVisible && _this.renderTextosUsuario(), React.createElement(MascarasContainer, null), React.createElement(CartulinaContainer, null));
    };

    _this.renderContenidoTipoPng = function () {
      var _this$props6 = _this.props,
          imagenUsuarioVisible = _this$props6.imagenUsuarioVisible,
          ajuste = _this$props6.ajuste,
          escala = _this$props6.escala,
          consolaLupa = _this$props6.consolaLupa,
          contenido = _this$props6.contenido,
          textosUsuarioVisible = _this$props6.textosUsuarioVisible;
      var factor = _this.state.factor;
      var lupa = consolaLupa.split(',')[0];
      return React.createElement(ContenidoVentana.ContenidoTipoPng, _extends({
        ajuste: ajuste || "auto",
        escala: escala || 100,
        factor: factor,
        lupa: lupa,
        imagenUsuarioVisible: imagenUsuarioVisible
      }, contenido), textosUsuarioVisible && _this.renderTextosUsuario(), React.createElement(MascarasContainer, null), React.createElement(CartulinaContainer, null));
    };

    _this.renderTextosUsuario = function () {
      var _this$props7 = _this.props,
          textosUsuario = _this$props7.textosUsuario,
          textosUsuarioTextoAyuda = _this$props7.textosUsuarioTextoAyuda,
          modoCrearTextoUsuario = _this$props7.modoCrearTextoUsuario,
          configTextosUsuario = _this$props7.configTextosUsuario,
          onCrearTextoUsuario = _this$props7.onCrearTextoUsuario,
          onActualizarTextoUsuario = _this$props7.onActualizarTextoUsuario,
          libroIdGuardado = _this$props7.libroIdGuardado,
          numPaginaGuardado = _this$props7.numPaginaGuardado,
          numZonaGuardado = _this$props7.numZonaGuardado;
      var factor = _this.state.factor;
      return React.createElement('div', {
        id: 'contenedor-textos',
        className: 'transparencia',
        style: {
          pointerEvents: 'none'
        }
      }, React.createElement(PanelTextos, {
        tamFuenteBase: _this.state.tamFuenteBase * factor / 100,
        textos: textosUsuario,
        textoAyuda: textosUsuarioTextoAyuda,
        modoCrear: modoCrearTextoUsuario,
        config: configTextosUsuario,
        onCrear: function onCrear(tipo, x, y, textoHtml) {
          return onCrearTextoUsuario(tipo, x, y, textoHtml, libroIdGuardado, numPaginaGuardado, numZonaGuardado);
        },
        onActualizar: onActualizarTextoUsuario
      }));
    };

    _this.handleResize = function (w, h, anchoPorcentaje, altoPorcentaje) {
      _this.setState({
        width: w,
        height: h
      });
    };

    _this.forzarMensajeCaducidad = function () {
      _this.setState({
        contadorForzarMensajeCaducidad: _this.state.contadorForzarMensajeCaducidad + 1
      });
    };

    _this.state = {
      width: null,
      height: null,
      factor: 100,
      contadorForzarMensajeCaducidad: 0,
      cajaEnlacesVentanaAbierta: false,
      tamFuenteBase: TAM_FUENTE_BASE_NOMINAL
    };
    return _this;
  }

  PrimeraVentana.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('keydown', this.mostrarInfoZona, false);

    if (window.modoTrabajo) {
      window.console.info("zona", this.props.libroId, this.props.numPagina, this.props.numZona);
      window.console.info("contenido", this.props.contenido);
      window.console.info("botones", this.props.botones);
    }
  };

  PrimeraVentana.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('keydown', this.mostrarInfoZona, false);
  };

  PrimeraVentana.prototype.renderBotonera = function renderBotonera(forzarLupaNO) {
    var _props = this.props,
        consolaAudio = _props.consolaAudio,
        textoTrack = _props.textoTrack,
        consolaLupa = _props.consolaLupa,
        botones = _props.botones,
        flotante = _props.flotante,
        onBoton = _props.onBoton,
        onCerrar = _props.onCerrar; // const marcoAmpliacionId = this.getMarcoAmpliacionId();

    return React.createElement(Botonera // marcoAmpliacionId={ marcoAmpliacionId }
    , {
      flotante: flotante,
      consolaLupa: consolaLupa,
      consolaAudio: consolaAudio,
      textoTrack: textoTrack,
      botones: botones,
      onCerrar: onCerrar,
      onBoton: onBoton,
      onZoomMas: this.zoomMas,
      onZoomInicial: this.zoomInicial,
      onZoomMenos: this.zoomMenos,
      forzarLupaNO: forzarLupaNO,
      factorActual: this.state.factor,
      configVentana: this.props.configPrimeraVentana
    });
  };

  PrimeraVentana.prototype.devolverZonaCreditos = function devolverZonaCreditos(objeto, arrayZonas) {
    objeto.clase === 'botonCreditos' && arrayZonas.push(objeto.zona);
  };

  PrimeraVentana.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _props2 = this.props,
        libroId = _props2.libroId,
        numPagina = _props2.numPagina,
        numZona = _props2.numZona;

    if (prevProps.libroId !== libroId || prevProps.numPagina !== numPagina || prevProps.numZona !== numZona) {
      this.setState({
        factor: 100
      });
    }
  };

  PrimeraVentana.prototype.render = function render() {
    var _this2 = this;

    var abierta = this.props.abierta;
    var _props3 = this.props,
        contenido = _props3.contenido,
        flotante = _props3.flotante,
        escalable = _props3.escalable,
        tieneAnimacion = _props3.tieneAnimacion,
        configPortada = _props3.configPortada,
        configIndice = _props3.configIndice,
        mensajeCaducidad = _props3.mensajeCaducidad;
    var _props4 = this.props,
        libroId = _props4.libroId,
        numPagina = _props4.numPagina,
        numZona = _props4.numZona;
    var tipo = contenido.tipo;
    var forzarLupaNO = tipo === 'zoom' || tipo === 'png' ? false : true; // const forzarLupaNO = (tipo === 'zoom') ? false : true

    var clasesExtra = 'zona' + libroId + Util.pad3(numPagina) + '_' + numZona;
    var zonasCreditos = [];
    configPortada.zonaCreditos && zonasCreditos.push(configPortada.zonaCreditos);

    if (configIndice[libroId]) {
      var botoneraIndice = configIndice[libroId].botoneraIndice;

      for (var keyPosicion in botoneraIndice) {
        if (botoneraIndice.hasOwnProperty(keyPosicion)) {
          this.devolverZonaCreditos(botoneraIndice[keyPosicion], zonasCreditos);

          for (var keyBoton in botoneraIndice[keyPosicion]) {
            this.devolverZonaCreditos(botoneraIndice[keyPosicion][keyBoton], zonasCreditos);

            for (var keyInteriores in botoneraIndice[keyPosicion][keyBoton]) {
              this.devolverZonaCreditos(botoneraIndice[keyPosicion][keyBoton][keyInteriores], zonasCreditos);
            }
          }
        }
      }
    }

    var esZonaCreditos = zonasCreditos.includes(libroId + Util.pad3(numPagina) + '.' + numZona);
    var mostrarMensajeCaducidad = esZonaCreditos && mensajeCaducidad.visible || this.state.contadorForzarMensajeCaducidad > 10;
    return React.createElement(VentanaSimple, {
      clasesExtra: clasesExtra,
      tieneAnimacion: tieneAnimacion,
      flotante: flotante,
      escalable: escalable,
      abierta: abierta,
      onResize: this.handleResize
    }, this.renderBotonera(forzarLupaNO), abierta && tipo === 'zoom' && this.renderContenidoTipoZoom(), abierta && tipo === 'video' && this.renderContenidoTipoVideo(), abierta && tipo === 'funcion,abrirIframe' && this.renderContenidoTipoIframe(), abierta && tipo === 'funcion,abrirEjercicio' && this.renderContenidoTipoIframe(), abierta && tipo === 'funcion,abrirEjercicioGG' && this.renderContenidoTipoIframe(), abierta && tipo === 'ejercicio' && this.renderContenidoTipoIframe(), abierta && tipo === 'historia' && this.renderContenidoTipoHistoria(), abierta && tipo === 'flashcards' && this.renderContenidoTipoFlashcards(), abierta && tipo === 'png' && this.renderContenidoTipoPng(), React.createElement('div', {
      className: 'botonInfoCaducidad',
      onClick: function onClick() {
        return _this2.forzarMensajeCaducidad();
      },
      style: {
        position: 'fixed',
        width: '10px',
        height: '10px',
        opacity: 0.01,
        bottom: '0px',
        left: '0px'
      }
    }), mostrarMensajeCaducidad && React.createElement('div', {
      className: 'infoCaducidad',
      style: {
        width: '100%',
        backgroundColor: '#fff',
        textAlign: 'right',
        userSelect: 'none'
      }
    }, mensajeCaducidad.mensaje));
  };

  return PrimeraVentana;
}(Component), _class.defaultProps = {
  abierta: false,
  tieneAnimacion: true,
  escalable: false,
  factor: 100
}, _temp);
PrimeraVentana.propTypes = process.env.NODE_ENV !== "production" ? {
  abierta: t.bool.isRequired,
  tieneAnimacion: t.bool.isRequired,
  escalable: t.bool.isRequired,
  flotante: t.bool.isRequired,
  configPrimeraVentana: t.object,
  configLibros: t.object,
  libroId: t.string.isRequired,
  numPagina: t.number.isRequired,
  numZona: t.number.isRequired,
  libroIdGuardado: t.string.isRequired,
  numPaginaGuardado: t.number.isRequired,
  numZonaGuardado: t.number.isRequired,
  // ancho: t.oneOfType([t.string, t.number]),
  // alto: t.oneOfType([t.string, t.number]),
  // botonera
  botones: t.array.isRequired,
  onBoton: t.func,
  // comportamiento ventana respecto al contenido
  ajusteInicial: t.string,
  // lupa (se integra en la botonera)
  consolaLupa: t.string.isRequired,
  onZoomMas: t.func,
  onZoomInicial: t.func,
  onZoomMenos: t.func,
  // consola de audio ( se integra en la botonera)
  consolaAudio: t.string.isRequired,
  textoTrack: t.string,
  // boton cerrar (se integra en la botonera)
  onCerrar: t.func.isRequired,
  // contenido
  contenido: t.shape({
    id: t.string,
    tipo: t.string,
    libroId: t.string,
    // numPagina: t.number,
    numZona: t.number,
    imagen: t.string,
    coordenadas: t.array
  }).isRequired,
  ajuste: t.string.isRequired,
  escala: t.number,
  configPortada: t.object,
  configIndice: t.object,
  mensajeCaducidad: t.object,
  // pizarra
  // dataKey: t.string,
  pizarra: t.any,
  imagenUsuarioVisible: t.bool,
  // textos usuario
  textosUsuarioTextoAyuda: t.string.isRequired,
  textosUsuario: t.arrayOf(t.shape({
    id: t.string.isRequired,
    x: t.number.isRequired,
    y: t.number.isRequired,
    textoHtml: t.string.isRequired
  })),
  configTextosUsuario: t.object.isRequired,
  textosUsuarioVisible: t.bool,
  modoCrearTextoUsuario: t.bool,
  onCrearTextoUsuario: t.func,
  onActualizarTextoUsuario: t.func
} : {};
export default PrimeraVentana;